import { Box } from "@chakra-ui/react";

export const HIGH_GROWTH_VAULT_STRINGS = {
  HEADER: {
    TITLE: "High Gain Vault",
    INSURED_LINK:
      "https://kerneldao.gitbook.io/kernel/getting-started/gain/high-growth-gain/insurance-coverage",
    STATS: {
      TVL: "Vault TVL",
      APY: "Estimated APR",
    },
  },
  ASSETS_ACCEPTED: {
    heading: "Assets accepted",
    list: [
      {
        key: "eth",
        title: "ETH",
        iconKey: "/assets/eth_blue.png",
      },
      {
        key: "rsETH",
        title: "rsETH",
        iconKey: "/assets/rseth.png",
      },
      {
        key: "stETH",
        title: "stETH",
        iconKey: "/assets/stETH.svg",
      },
      {
        key: "ethx",
        title: "ETHx",
        iconKey: "/assets/ethx.svg",
      },
    ],
  },
  SECTIONS: {
    DEPOSIT_WITHDRAW: {
      TABS: [
        { key: "deposit", title: "Deposit" },
        { key: "withdraw", title: "Withdraw" },
      ],
      DISCLAIMER: {
        DEPOSIT: "",
        WITHDRAW: (
          <>
            The withdrawal amount will be{" "}
            <Box as="span" fontWeight="500" color="textPrimary">
              auto-claimed
            </Box>{" "}
            to your address in 3-4 days once you request a withdrawal. Check
            pending claims in the &apos;Claims&apos; section. While in the
            withdrawal queue, you will not earn any position rewards or points.
            All your withdrawals in a day will be fulfilled as a single
            transaction.
          </>
        ),
      },
    },
    PORTFOLIO: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "apr_reports", title: "Strategy Reports", isNew: true },
        { key: "holdings", title: "My Holdings" },
      ],
      HOLDINGS: {
        walletConnect: "Connect your wallet to view your holdings",
        nexusMutual: {
          title:
            "Insure your hgETH with Nexus Mutual. 10% discount for Gain users.",
          CTA: "Get insurance",
          imgSrc: "/assets/vaults/nexus.svg",
        },
      },
      POINTS: {
        walletConnect: "Connect wallet to view your points",
        supported: [],
      },
      CLAIMS: {
        walletConnect: "Connect wallet to view your claims",
        noData: "No claims data available",
        COLUMNS: ["Asset", "Amount", "Status"],
      },
      HISTORY: {
        walletConnect: "Connect wallet to view your history",
        COLUMNS: ["Date", "Time", "Transaction", "Asset", "Amount", "Status"],
      },
      APR_REPORTS: {
        walletConnect: "Connect wallet to view your history",
        cmsKey: "high_growth_vault",
        COLUMNS: [
          {
            name: "Strategy",
            key: "strategy_name",
            hasImage: true,
          },
          {
            name: "Allocation",
            isNumeric: true,
            key: "allocation",
          },
          {
            name: "APR on strategy",
            isNumeric: true,
            key: "apr",
            tooltipText:
              "APR offered by the selected strategy, based on its current performance.",
          },
          {
            name: "Realized APR",
            isNumeric: true,
            key: "realized_apr",
            tooltipText:
              "The portion of APR that has been finalised. It reflects returns that are no longer subject to change.",
          },
          {
            name: "Accruing APR",
            isNumeric: true,
            key: "accruing_apr",
            tooltipText:
              "The portion of APR that is currently accruing and will be finalised over time, based on ongoing performance.",
          },
          {
            name: "APR on allocation",
            isNumeric: true,
            key: "apr_on_allocation",
            tooltipText:
              "Effective APR based on the strategy's rate and the proportion of assets allocated to it.",
          },
        ],
      },
    },
    OVERVIEW: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "strategies", title: "Strategies" },
      ],
      DATA: {
        MAIN: {
          heading: "Unlock top rewards with DeFi",
          headingIcon: "/assets/vaults/hgETHOverview.png",
          desc: "Assets are deposited in AAVE, Compound, and other strategies to earn top rewards. Deposits mint hgETH, a liquid token usable across DeFi for added yield.",
          disclaimerLink:
            "https://docs.google.com/document/d/1KnAvqWDWXr-GpU3c1g_CtQU6y1fpxX9oaGRcrx4lcWQ",
          insuredText:
            "This vault is insured for up to 50% of TVL against hacks and protocol failure",
        },
        FEES: {
          heading: "Fees & Details",
          data: [
            {
              key: "platform",
              title: "Platform fee",
              value: "1.5%",
              tooltip: "Annual fee charged for managing the vault",
            },
            {
              key: "performance",
              title: "Performance fee",
              value: "20%",
              tooltip: "Annual fee charged on rewards generated by the vault",
            },
            {
              key: "redemption",
              title: "Redemption period",
              value: "3 days",
            },
          ],
        },
        PARTNERS: {
          heading: "Vault Partners",
          details: [
            {
              key: "ultrayield",
              imgSrc: "/assets/vaults/ultrayield.svg",
              link: "https://kerneldao.gitbook.io/kernel/getting-started/gain/high-growth-gain#vault-partners",
              imageWidth: 70,
            },
            {
              key: "upshift",
              imgSrc: "/assets/vaults/upshift.svg",
              link: "https://kerneldao.gitbook.io/kernel/getting-started/gain/high-growth-gain#vault-partners",
              imageWidth: 50,
            },
          ],
        },
      },
      STRATEGIES: {
        COLUMNS: [
          {
            label: "Strategy",
            accessor: "strategy",
          },
          {
            label: "Allocation %",
            accessor: "allocation",
          },
        ],
      },
      RESERVES: {
        COLUMNS: ["Date", "Time", "Block", "Asset", "Amount", "Txn"],
      },
    },
  },
};
